/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderItemModifierSchema } from "./repeatMobileOrderItemModifierSchema.ts";

export const repeatMobileOrderItemGroupUnionModifierSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(repeatMobileOrderItemModifierSchema),
});
